/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import { Component } from 'react'
import { reduxForm } from 'redux-form'

import { StyledSubHeading } from 'components/headings'
import { Form } from 'components/forms'
import { SaveButton } from 'components/buttons'
import BabyRegistryInfoFieldset from 'registry/forms/registry-info-fieldset'
import RegistryPreferencesFieldset from 'registry/forms/registry-preferences-fieldset'
import NameFieldset from 'registry/forms/name-fieldset'
import PartnerAccessForm from 'registry/forms/partner-access-form'
import { getUserOwnsRegistry } from 'registry/reducers'

import { createValidator, required } from 'lib/form-validation'
import { saveRegistryInfo } from 'registry/actions'
import DateSelect from 'components/date-select'
import { Col, Row } from 'react-bootstrap'

export const validate = createValidator({
  firstName: [required],
  lastName: [required],
})

const today = new Date()
const currentYear = today.getFullYear()
const years = [currentYear - 1, currentYear, currentYear + 1]

class BabyRegistryInfo extends Component {
  // eslint-disable-next-line class-methods-use-this
  handleSubmit(data, dispatch) {
    return dispatch(saveRegistryInfo(data))
  }

  render() {
    const {
      fields: { registry, user },
    } = this.props

    return (
      <div>
        <StyledSubHeading>Registry Info</StyledSubHeading>
        <Form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))}>
          {this.props.userOwnsRegistry ? (
            <div>
              <NameFieldset
                firstName={user.firstName}
                lastName={user.lastName}
              />

              <NameFieldset
                firstNameLabel="Partner's First Name"
                firstName={registry.family.partner.firstName}
                firstNamePlaceholder="Optional"
                lastNameLabel="Partner's Last Name"
                lastName={registry.family.partner.lastName}
                lastNamePlaceholder="Optional"
              />

              <PartnerAccessForm
                registryId={registry.id.value}
                firstName={registry.family.partner.firstName.value}
                lastName={registry.family.partner.lastName.value}
              />

              <Row>
                <Col sm={6}>
                  <DateSelect
                    label="Arrival Date"
                    years={years}
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...registry.family.arrivalDate}
                  />
                </Col>
              </Row>
            </div>
          ) : null}

          <BabyRegistryInfoFieldset
            description={registry.description}
            title={registry.title}
            urlSlug={registry.urlSlug}
          />
          <StyledSubHeading className="h5">
            Registry Preferences
          </StyledSubHeading>
          <RegistryPreferencesFieldset
            priceAndAvailabilityUpdates={registry.updatePriceAndAvailability}
            showMultipleStores={registry.showMultipleStores}
          />
          <SaveButton submitting={this.props.submitting} pill />
        </Form>
      </div>
    )
  }
}

export default reduxForm(
  {
    form: 'BabyRegistryInfoForm',
    fields: [
      'registry.description',
      'registry.id',
      'registry.title',
      'registry.urlSlug',
      'registry.updatePriceAndAvailability',
      'registry.showMultipleStores',
      'registry.family.arrivalDate',
      'registry.family.hasPartner',
      'registry.family.partner.firstName',
      'registry.family.partner.lastName',
      'user.firstName',
      'user.lastName',
    ],
  },
  (state) => ({
    initialValues: {
      registry: {
        description: state.registry.description,
        id: state.registry.id,
        title: state.registry.title,
        urlSlug: state.registry.urlSlug,
        updatePriceAndAvailability: state.registry.updatePriceAndAvailability,
        showMultipleStores: state.registry.showMultipleStores,
        family: {
          hasPartner: state.registry.family.hasPartner,
          arrivalDate: state.registry.family.arrivalDate,
          partner: {
            firstName: state.registry.family.partner.firstName,
            lastName: state.registry.family.partner.lastName,
          },
        },
      },
      user: {
        firstName: state.user.firstName,
        lastName: state.user.lastName,
      },
    },
    userOwnsRegistry: getUserOwnsRegistry(state),
    onSubmitSuccess: () => {
      PubSub.publish(BLConstants.FLASH_MESSAGE, {
        message: 'Your registry info has been updated!',
        variant: 'success',
      })
    },
  })
)(BabyRegistryInfo)
